module.exports = __webpack_public_path__ + "static/media/aplicacao2.f41d7515.png";